<template>
  <div>
    <nav class="header">
      <div class="headerMain flex">
        <img src="../assets/newlogo2.png" alt="" style="vertical-align: super;">
        <div class="headright flex">
          <div class="search_input">
            <input placeholder="搜索大学" v-model="search">
            </input>
            <router-link :to="'/schoolList?name='+search" class="el-input__icon search_icon" slot="suffix">
              <img src="../assets/search.png" alt="">
            </router-link>
          </div>
          <div class="vip flex">
            <div v-show="$store.state.isLogin==true" @click.stop="jump_path('/personalCenter')">
              <span>{{userInfo.province_name}}&nbsp|&nbsp{{userInfo.subject_type_1==1?'理科':'文科'}}&nbsp|&nbsp{{userInfo.score}}</span>
              <img src="../assets/index/xiugai1.png">
            </div>
          </div>
          <div v-show="$store.state.isLogin==false" @click="login" class="login">登录</div>
        </div>
      </div>
      <div class="nav">
        <ul>
          <li @click="jump_path('/')">首页</li>
          <li class="shuju" @click="jump_path('/chooseSubjects')">新高考选科
          </li>

          <li class="shuju">
            目标定制<i class="el-icon-arrow-down"></i>
            <div class="list" style="height: 100px;">
              <div @click="jump_path('/futureEasy')">目标定制</div>
              <div @click="jump_path('/growthRecord')">成长记录</div>
            </div>
          </li>
          <li @click="jump_path('/schoolList')">院校库</li>
          <li @click="jump_path('/specialtyList')">专业库</li>
          <li @click="jump_path('/zhiyeList')">职业库</li>
          <li class="shuju">志愿<i class="el-icon-arrow-down
"></i>
            <div class="list" style="left: -10px;">
              <div @click="jump_path('/aiList')">智能志愿</div>
              <div @click="jump_path('/artificialList?type=score')">人工志愿</div>
              <div @click="jump_path('/artificialList?type=equal')" v-show="teacher_show==true">同位分报志愿</div>
              <div @click="jump_path('/artificialList?type=diff')" v-show="teacher_show==true">线差报志愿</div>
              <div @click="jump_path('/artificialList?type=rank')" v-show="teacher_show==true">位次报志愿</div>
              <div @click="jump_path('/artificialList?type=pnmp')" v-show="teacher_show==true">PNMP报志愿</div>
              <div @click="jump_path('/artificialList?type=self')">自主志愿</div>

            </div>
          </li>
          <!-- <li>院校详情</li> -->
          <li class="shuju">历年数据<i class="el-icon-arrow-down
"></i>
            <div class="list">
              <div @click="jump_path('/yifenyiduan')">一分一段表</div>
              <div @click="jump_path('/provinceLine')">省控线</div>
            </div>
          </li>
          <li class="shuju">性格测试<i class="el-icon-arrow-down
          "></i>
            <div class="list">
              <div @click="jump_path('/mbti')">MBTI测试</div>
              <div @click="jump_path('/huolande')">霍兰德测试</div>
            </div>
          </li>
          <li class="shuju" @click="jump_path('/rank')">院校排名
          </li>
          <li class="shuju" @click="jump_path('/xinxi')">信息发布
          </li>
          <li class="shuju" @click="jump_path('/term')">专业术语
          </li>

          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'header',
    data() {
      return {
        search: '',
        path_to: '',
        islogin: this.$store.state.isLogin,
        userInfo: [],
        vipststus: '开通VIP',
        teacher_show: false
      }
    },
    created() {
      if (localStorage.getItem('userInfo')) {
        this.$http.getUserInfo().then(res => {
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          localStorage.setItem('teacher_show', res.data.teacher_show)
          this.userInfo = res.data
          this.teacher_show = res.data.teacher_show
          console.log(this.teacher_show)
        })
        if (this.userInfo.bind_card > 0) {
          this.vipststus = '已开通VIP'
        }
      }
      // if (localStorage.getItem('teacher_show')) {
      //   this.teacher_show = localStorage.getItem('teacher_show')
      // }
      // console.log(this.teacher_show == 'true')
    },
    methods: {
      open() {
        this.$store.commit('openVip', true);
      },
      login() {
        this.$store.commit('login', true);
      },
      outlogin() {
        localStorage.clear()
        this.$store.commit('logout', false);
        this.$router.push({
          path: '/'
        })
      },
      jump_path(path, number) {
        if (number == 1) {
          this.$message.warning('版本升级中,敬请期待!');
          return
        }
        this.path_to = path
        localStorage.setItem('activeurl', path)
        this.$router.push({
          path: path
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  $color: #C10B17;

  .login {
    background: #C10B17;
    border-radius: 4px;
    width: 70px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #FFF;
    cursor: pointer;
  }

  .shuju {
    position: relative;

    .list {
      width: 100px;

      position: absolute;
      background-color: #C10B17;
      color: #ffffff;
      z-index: 1999;
      top: 51px;
      left: 5px;
      display: none;
    }
  }

  .shuju:hover .list {
    display: block;
  }

  .nav {
    background-color: $color;
    height: 51px;
    width: 1280px;
    color: #ffffff;
    text-align: center;

    .navright {
      line-height: 51px;


      img {
        margin-left: 5px;
        vertical-align: middle;
      }
    }

    ul {
      width: 1200px;
      margin: 0 auto;
    }

    ul li {
      float: left;
      list-style: none;
      line-height: 51px;
      padding: 0 18px;
    }

    ul li:hover {
      cursor: pointer
    }
  }

  .vip {
    height: 42px;
    margin-left: 14px;
    position: relative;
    overflow: hidden;
    color: #333333;
    cursor: pointer;

    img {
      margin-left: 10px;
      vertical-align: middle;
    }

    .light {
      content: '';
      display: block;
      position: absolute;
      left: -100%;
      width: 100px;
      height: 20px;
      transform: rotate(-65deg);
      background: rgba(255, 255, 255, .5);
      animation: cross 1.5s linear infinite
    }

    @keyframes cross {
      from {}

      to {
        left: 100%;
        transform: rotate(-65deg);
      }
    }

    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
  }

  .navright:hover {
    cursor: pointer
  }

  .headerMain {
    width: 1280px;
    height: 100px;
    margin: 0 auto;
    justify-content: space-between;
  }

  .search_input {
    justify-content: space-between;
    position: relative;
  }

  .search_input input {
    width: 300px;
    outline: none;
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid $color;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 42px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    //border: none;
    //border: 1px solid #19CACA !important;
  }

  .search_icon {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 20px;
    top: 10px;
  }

  .header {
    width: 1280px;
    margin: 0 auto;
    // position: fixed;
    // top: 0;
    // height: 300px;
    // overflow: hidden;
  }

  .bar3 {
    background: #F9F0DA;
  }

  .bar3 form {
    background: #A3D0C3;
  }

  .bar3 input,
  .bar3 button {
    background: transparent;
  }

  .bar3 button {
    top: 0;
    right: 0;
  }

  .bar3 button:before {
    content: "\f002";
    font-family: FontAwesome;
    font-size: 16px;
    color: #F9F0DA;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue